import React, { type ReactNode } from 'react';

import './FullSizeScrollContainer.scss';

interface YatFullSizeScrollContainerProps {
    children: ReactNode;
}

const YatFullSizeScrollContainer = ({ children }: YatFullSizeScrollContainerProps) => {
    return <div className="yat-full-size-scroll-container">{children}</div>;
};

export default YatFullSizeScrollContainer;
